if (typeof G == 'undefined') G = {};
G.Animations = G.Animations || {};

G.Animations.getGameplayChestTHGiftRevealAnimation = function getGameplayChestTHGiftRevealAnimation() {
  var onComplete = new Phaser.Signal();
  return { animate: animate, onComplete: onComplete };

  function animate(game, target) {
    target.scale.setTo(0);
    target.alpha = 1;
    target.angle = -10;
    target.y = -20;

    game.add.tween(target.scale)
      .to({x: 1, y: 1}, 600, Phaser.Easing.Bounce.Out, true);

    var moveTween = game.add.tween(target)
      .to({y:-50},1200,Phaser.Easing.Sinusoidal.InOut, true)

    game.add.tween(target)
      .to({angle: 10},1200,Phaser.Easing.Sinusoidal.InOut,true)
      .onComplete.add(function() {
        target.scale.setTo(0);
        onComplete.dispatch();
      });
  }
};
